module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/outgoing-box-d768c50ec9337ccbcf9c39c4c15187e9.svg";